export default __webpack_public_path__ + "static/media/(63).c996694c.jpg";